import { ReactNode } from 'react';

import { Heading, StyledFlex, StyledMargin } from '@dreryk/react-components';

import { calendarTranslationKeys } from '../../translations';

import { CalendarSidePanelPortal, CalendarSidePanelPortalContainer } from './CalendarSidePanel.portal';
import { StyledCalendarSidePanel } from './CalendarSidePanel.styled';

type CalendarSidePanelProps = {
   readonly children?: ReactNode;
};

export const CalendarSidePanel = (props: CalendarSidePanelProps): JSX.Element => {
   return (
      <StyledCalendarSidePanel testId={'calendarSidePanel'} width={210}>
         <StyledFlex direction={'column'} gap={'20px'}>
            <Heading
               testId={'calendar'}
               content={calendarTranslationKeys.sidePanel.heading}
               type={'h2'}
               margin={'0px'}
               bold
            />
            <StyledFlex direction={'column'} gap={'12px'}>
               <CalendarSidePanelPortalContainer placement={'selectors'} />
            </StyledFlex>
         </StyledFlex>
         <StyledMargin top={-20} bottom={-24} left={-22}>
            <CalendarSidePanelPortalContainer placement={'miniCalendar'} />
         </StyledMargin>
         <CalendarSidePanelPortalContainer placement={'underMiniCalendar'} />
         {props.children}
      </StyledCalendarSidePanel>
   );
};

CalendarSidePanel.Portal = CalendarSidePanelPortal;
